// import React, {useState, useEffect} from 'react'
// import Header from '../Components/Header'
// import SideMenu from '../Components/SideMenu'

// const ProjectApprovalPendingList = () => {
//   const [compensationDetails, setCompensationDetails] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const rowsPerPage = 10;


//   const fileredProject = compensationDetails.filter((project) => {
//     return(compensationDetails)
//   })

//   //pagination logic
//   const totalPages = Math.ceil(fileredProject.Length / rowsPerPage);
//   const currentRows = fileredProject.slice(
//     (currentPage - 1) * rowsPerPage,
//     currentPage * rowsPerPage
//   )

//   const handlePrevPage = () => {
//     setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
//   }

//   const handleNextPage = () => {
//     setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
//   }

//   const fetchCompensationDetails = async () => {
//       debugger
//       try {
//         const response = await fetch(
//           "https://backurrda.sarmar.co.in/api/DetailsInsert/CompensationDetailsGet/"
//         );
//         if (response.ok) {
//           const data = await response.json();
//           setCompensationDetails(data); // Update state with fetched data
//           console.log(data);
//         } else {
//           console.error("Failed to fetch details. HTTP Status:", response.status);
//         }
//       } catch (error) {
//         console.error("Error fetching details:", error);
//       }
//     };
  
//     useEffect(() => {
//       fetchCompensationDetails();
//     }, []);


//   return( 
//     <div className="flex flex-col min-h-screen overflow-auto">
//       <div className="px-4">
//         <Header />
//       </div>
//       <div className="flex flex-1 overflow">
//         <SideMenu className="hidden lg:block w-1/4 bg-gray-200" />
//         <div className="flex-1 px-6 py-4 overflow-auto">
//           <div className="border-b pb-2 flex items-center justify-between text-xl font-bold">
//             <h1>Project Approval Pending List</h1>
//           </div>
//           <section className="mt-10">
//             <table className="w-full">
//               <thead>
//                 <tr className="border-b-2">
//                   <th className="p-2">S. No.</th>
//                   <th className="p-2">Road Name</th>
//                   <th className="p-2">Road Length</th>
//                   <th className="p-2">Tehsil</th>
//                   <th className="p-2">Proposal Date</th>
//                   <th className="p-2">Sanctioned Amount</th>
//                   <th className="p-2">Status</th>
//                 </tr>
//               </thead>
//               <tbody>
//               {compensationDetails.map((beneficiary, index) => (
//               <tr key={`${beneficiary.CompensationId}-${index}`}>
//                   <td className="p-2"><input className="w-full" type="text"  value={index+1}/></td>
//                   <td className="p-2"><input className="w-full" type="text" value={beneficiary.RoadName} /></td>
//                   <td className="p-2"><input className="w-full" type="text" value={beneficiary.RoadLengthKM} /></td>
//                   <td className="p-2"><input className="w-full" type="text" value={beneficiary.Tehsil_code} /></td>
//                   <td className="p-2"><input className="w-full" type="text" value={beneficiary.SanctionedDate} /></td>
//                   <td className="p-2"><input className="w-full" type="text" value={beneficiary.SanctionedAmount} /></td>
//                   <td className="p-2 text-center">
//                     <button className="text-[#DD9B1F] px-4 py-2 border bg-[#f7d4a4] rounded">Pending</button>
//                   </td>
//                 </tr>
//                 ))}
//               </tbody>
//             </table>
//           </section>
//         <div className='flex justify-between items-center mt-4'>
//           <button
//           onClick={handlePrevPage}
//           disabled={currentPage === 1}
//           className='px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed'
//           >
//             Previous
//           </button>
//           <span>Page {currentPage} of {totalPages}</span>
//           <button
//           onClick={handleNextPage}
//           disabled={currentPage === totalPages}
//           className='px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed'
//           >
//             Next
//           </button>
//         </div>
//         </div>
       
//       </div>
//     </div>
//   )
// }

// export default ProjectApprovalPendingList


import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import SideMenu from '../Components/SideMenu';
import { useNavigate } from 'react-router-dom';

const ProjectApprovalPendingList = () => {
  debugger
  const [compensationDetails, setCompensationDetails] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [sanctioneddate, setSanctionedDate] = useState();
  const rowsPerPage = 10;
  const navigate = useNavigate();

  const handleDetails = (beneficiary) => {
    debugger
    const compensationId = beneficiary?.CompensationId;
    navigate('/CompensationProposalDetail', {state : { beneficiary,compensationId }})
  }

  const fetchCompensationDetails = async () => {
    debugger
    try {
      const response = await fetch(
        'https://backurrda.sarmar.co.in/api/DetailsInsert/CompensationDetailsGet/'
      );
      if (response.ok) {
        const data = await response.json();
        setCompensationDetails(data);
        console.log(data);
      } else {
        console.error('Failed to fetch details. HTTP Status:', response.status);
      }
    } catch (error) {
      console.error('Error fetching details:', error);
    }
  };

  useEffect(() => {
    fetchCompensationDetails();
  }, []);

  // useEffect(() => {
  //   debugger
  //   if (beneficiary.SanctionedDate) {
  //     const dateObj = new Date(beneficiary.SanctionedDate);
  //     const formatted = dateObj.toISOString().split("T")[0];
  //     setSanctionedDate(formatted);      
  //   }
  // },[beneficiary.SanctionedDate])

  const totalPages = Math.ceil(compensationDetails.length / rowsPerPage);
  const currentRows = compensationDetails.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  return (
    <div className="flex flex-col min-h-screen">
      <div className="px-4">
        <Header />
      </div>
      <div className="flex flex-1">
        <SideMenu className="hidden lg:block lg:w-1/4 bg-gray-200" />
        <div className="flex-1 px-6 py-4 h-full max-h-[calc(100vh-80px)] overflow-y-auto">
          <div className="border-b pb-2 flex items-center justify-between text-lg md:text-xl font-bold">
            <h1>Project Approval Pending List</h1>
          </div>
          <section className="mt-4 md:mt-10">
            <div className="overflow-x-auto">
              <table className="w-full border-collapse ">
                <thead>
                  <tr className="border-b-2 ">
                    <th className="p-2 text-sm md:text-base text-start">S. No.</th>
                   <th className="p-2 text-sm md:text-base text-start">Road Name</th>
                   <th className="p-2 text-sm md:text-base text-start">Road Length</th>
                   <th className="p-2 text-sm md:text-base text-start">Tehsil</th>
                   <th className="p-2 text-sm md:text-base text-start">Proposal Date</th>
                   <th className="p-2 text-sm md:text-base text-start">Sanctioned Amount</th>
                   <th className="p-2 text-sm md:text-base text-start">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {currentRows.map((beneficiary, index) => {
                    // const dateObj = new Date(beneficiary.SanctionedDate);
                    // const formattedDate = dateObj.toISOString().split("T")[0];
                    let formattedDate = '';

    // Check if SanctionedDate is valid before formatting
    if (beneficiary.SanctionedDate) {
      const dateObj = new Date(beneficiary.SanctionedDate);
      if (!isNaN(dateObj)) {
        formattedDate = dateObj.toISOString().split("T")[0];
      } else {
        formattedDate = 'Invalid Date';  // Optionally handle invalid date
      }
    }
                    return(
                    <tr key={`${beneficiary.CompensationId}-${index}`}>
                      <td className="p-2 text-sm ">
                        
                        {index + 1 + (currentPage - 1) * rowsPerPage}
                      </td>
                      <td className="p-2 text-start">
                        <input value={beneficiary.RoadName}/></td>
                        <td className="p-2 text-start">
                        <input value={beneficiary.RaodLengthKM}/></td>
                        <td className="p-2 text-start">
                        <input value={beneficiary.TehsilNameHindi}/></td>
                        <td className="p-2 text-start">
                        <input value={formattedDate}/></td>
                        <td className="p-2 text-start">
                        <input value={beneficiary.SanctionedAmount}/></td>
                      <td className="p-2 text-start">
                        <button className="text-[#DD9B1F] px-4 py-2 border bg-[#f7d4a4] rounded"
                        onClick={() => handleDetails(beneficiary)}
                        >
                          Pending
                        </button>
                      </td>
                    </tr>
                  );
                  })}
                </tbody>
              </table>
            </div>
          </section>
          <div className="flex flex-col md:flex-row justify-between items-center mt-4">
            <button
              onClick={handlePrevPage}
              disabled={currentPage === 1}
              className="px-3 py-1 mb-2 md:mb-0 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Previous
            </button>
            <span className="text-sm md:text-base">
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              className="px-3 py-1 mt-2 md:mt-0 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectApprovalPendingList;

